<template>
  <div
    :class="{'aplly-column': column}"
    class="zoox-component zoox-input-document"
  >
    <z-select
      :label="$t('document')"
      :value="type"
      :items="documentTypeOptions"
      @change="onChangeType"
    />
    <z-input
      ref="value"
      :mask="mask"
      :label="label"
      :value="value"
      :disabled="!type"
      :clearable="clearable"
      @input="$emit('update:value', $event)"
    />
  </div>
</template>

<script>
import find from 'lodash.find'

/**
 * @displayName Input Document
 */
export default {
  name: 'ZInputDocument',
  props: {
    type: {
      type: String,
    },
    value: {
      type: String,
    },
    /**
     * Adiciona funcionalidade de "limpar" o input
     */
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    column: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      preconfigMasks: {
        cpf: '###.###.###-##',
      },
    }
  },
  computed: {
    documentTypeOptions() {
      return [
        {text: this.$t('cpf'), value: 'cpf'},
        {text: this.$t('passport'), value: 'passport'},
        {
          text: this.$t('birth_certificate'),
          value: 'birth_certificate',
        },
        {
          text: this.$t('foreign_identity'),
          value: 'foreign_identity',
        },
        {text: this.$t('identity'), value: 'identity'},
      ]
    },
    label() {
      const currentType = find(this.documentTypeOptions, {value: this.type})

      return currentType ? currentType.text : ''
    },
    mask() {
      return this.preconfigMasks[this.type] || '###################'
    },
  },

  methods: {
    onChangeType(type) {
      this.$emit('update:value', '')
      this.$emit('update:type', type)
    },
  },

  i18n: {
    messages: {
      pt: {
        document: 'Documento',
        cpf: 'CPF',
        passport: 'Passaporte',
        birth_certificate: 'Certidão de nascimento',
        foreign_identity: 'Identidade estrangeira',
        identity: 'Identidade',
      },
      en: {},
      es: {},
      fr: {
        document: 'Document',
        cpf: 'CPF',
        passport: 'Passeport',
        birth_certificate: 'Acte de naissance',
        foreign_identity: 'Identité étrangère',
        identity: 'Identité',
      },
      tr: {
        document: 'Belge',
        cpf: 'CPF',
        passport: 'Pasaport',
        birth_certificate: 'Doğum belgesi',
        foreign_identity: 'Yabancı kimlik',
        identity: 'Kimlik',
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-input-document {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 8px;
}

.aplly-column {
  display: flex;
  flex-direction: column;
}
</style>
